// Держим в синхроне с AUTH_SERVICE_SMS_RESEND_INTERVAL_SECONDS на бэкенде - это UI-таймер
// для той же паузы, что бэкенд реально применяет (см. pkg/sms-rate-limit).
export const RESEND_DELAY = 120;
// Не используется - роль заставки теперь у статического сплэша в index.html (см. main.ts).
// export const INTRO_MIN_DURATION_MS = 4000;
export const TIMER_KEY = 'resend-timer-expire';
export const PHONE_KEY = 'saved-phone-user';
export const QUERY_PHONE_KEY = 'phone';
export const SESSION_ID_KEY = 'client-session-id';
export const USER_PHONE_KEY = 'user-phone';
export const AUTH_TYPE_KEY = 'authorization-type';
export const USER_REGISTRATION_KEY = 'user-reginstration-info';
export const PRIVACY_URL = 'https://reforce.group/privacy';
export const REGULAR_EMAIL = '[A-Za-z0-9._%-]+@[A-Za-z0-9._%-]+\\.[a-z]{2,3}';
// export const REGULAR_PHONE = '^\\+7 \\d{3} \\d{3}-\\d{2}-\\d{2}$'; // новый дизайн (маска без скобок), временно откачено
export const REGULAR_PHONE = '^\\+7 \\(\\d{3}\\) \\d{3}-\\d{2}-\\d{2}$';
export const REGULAR_RU = '^[А-Яа-яЁё]+$';
export const enum scrollType {
  firstName,
  middleName,
  lastName,
  phone,
  email,
  confirm,
}
